const getDefaultState = () => {
  return {
    gatewaysArea: '',
    gatewaysGW: '',
    gatewaysAddDevice: false,
    devicesArea: '',
    devicesGW: '',
    mapArea: '',
    mapGW: '',
  };
};

const state = getDefaultState();

const mutations = {
  RESET_SELECTS_STATE: (state) => {
    state.gatewaysArea = '';
    state.gatewaysGW = '';
    state.gatewaysAddDevice = false;
    state.devicesArea = '';
    state.devicesGW = '';
    state.mapArea = '';
    state.mapGW = '';
  },
  SET_GATEWAYS_AREA: (state, area) => {
    state.gatewaysArea = area;
  },
  SET_GATEWAYS_GATEWAY: (state, gateway) => {
    state.gatewaysGW = gateway;
  },
  SET_GATEWAYS_ADDDEVICE: (state, addDevice) => {
    state.gatewaysAddDevice = addDevice;
  },
  SET_DEVICES_AREA: (state, area) => {
    state.devicesArea = area;
  },
  SET_DEVICES_GATEWAY: (state, gateway) => {
    state.devicesGW = gateway;
  },
  SET_MAP_AREA: (state, area) => {
    state.mapArea = area;
  },
  SET_MAP_GATEWAY: (state, gateway) => {
    state.mapGW = gateway;
  },
};

const actions = {
  resetSelectsState({ commit }) {
    commit('RESET_SELECTS_STATE');
  },
  setGatewaysArea({ commit }, area) {
    commit('SET_GATEWAYS_AREA', area);
  },

  setGatewaysGW({ commit }, gateway) {
    commit('SET_GATEWAYS_GATEWAY', gateway);
  },
  setGatewaysAddDevice({ commit }, addDevice) {
    commit('SET_GATEWAYS_ADDDEVICE', addDevice);
  },
  setDevicesArea({ commit }, area) {
    commit('SET_DEVICES_AREA', area);
  },
  setDevicesGW({ commit }, gateway) {
    commit('SET_DEVICES_GATEWAY', gateway);
  },
  setMapArea({ commit }, area) {
    commit('SET_MAP_AREA', area);
  },
  setMapGW({ commit }, gateway) {
    commit('SET_MAP_GATEWAY', gateway);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
